import axios from "../../axios";
import * as routes from "../../api-routes/Manager/Analytics";

export const getRedemptionsGraphReq = (token, queryParams) => {
  return axios.get(
    `${process.env.REACT_APP_DASHBOARD_ENDPOINT}${routes.getRedemptionsChart}`,
    {
      params: {
        ...queryParams,
      },
      headers: {
        token,
      },
    }
  );
};
